module.exports = __webpack_public_path__ + "img/game1.819db57b.png";